<!--
<app-page-title title="Checkout" [children]="[{title: 'Checkout'}]"></app-page-title>
-->

<div class="max-w-3xl mx-auto px-6 py-12">
  <div class="bg-white rounded-xl shadow-lg text-center p-8">
    <h3 class="text-3xl font-serif text-gold mb-4">Thank you for your order!</h3>
    <p class="text-gray-600 mb-2">Your order has been placed and will be processed as soon as possible.</p>
    <p class="text-gray-600 mb-6">You will be receiving an email shortly with confirmation of your order.</p>
    <div class="mt-6">
      <a routerLink="/home" 
         class="add-to-cart-btn inline-flex items-center justify-center transition-all duration-300 relative overflow-hidden bg-gradient-to-r from-gold to-yellow-600 hover:from-red-700 hover:to-red-600 text-white font-serif text-base sm:text-lg font-bold px-6 py-3 rounded-full">
        <span class="flex items-center">
          <i class="fas fa-shopping-bag mr-2"></i>
          <span>Go Back Shopping</span>
        </span>
      </a>
    </div>
  </div>
</div>
